// PhotoViewerModal.js

import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { PhotoViewerModalStyled } from "./styles";

const PhotoViewerModal = ({ isOpen, onClose, person }) => {
  return (
    <Dialog
      visible={isOpen}
      style={{ width: "30vw" }}
      header="Foto"
      onHide={onClose}
      footer={
        <div>
          <Button
            label="Cerrar"
            icon="pi pi-times"
            onClick={onClose}
            className="p-button-text"
          />
        </div>
      }
    >
      <PhotoViewerModalStyled>
        <div className="modal-content">
          {person?.photoUrl ? (
            <img
              src={person.photoUrl}
              alt={`Foto de ${person.fullName}`}
              className="preview-image"
            />
          ) : (
            <p>No hay foto disponible</p>
          )}
        </div>
      </PhotoViewerModalStyled>
    </Dialog>
  );
};

export default PhotoViewerModal;
